import register from '../register.js';
import throttle from './util/throttle.js';
import jump     from './util/jump';

register( 'main-nav', () => {

  let html           = document.querySelector('html');
  let body           = document.querySelector('body');
  let bodyWrap       = document.querySelector('.body-wrap');
  let nav            = document.querySelector('.header__container');
  let burger         = document.querySelector('.hamburger');
  let mobileNav      = document.querySelector('.nav-list--mobile');
  let headerInner    = document.querySelector('.header__inner');
  let checkAvail     = document.querySelector('.js-check-avail-mobile-nav');
  let contactUs      = document.querySelector('.js-contact-us-mobile-nav');
  let topCheckAvail  = document.querySelector('.js-check-avail-header');
  let referralBanner = document.querySelector('.referral-banner');
  let referralClose  = document.querySelector('.js-referralClose');
  let hasCheckAvail  = Boolean( document.querySelector('#check-availability') );
  let activeClass    = 'is-pinned';
  let checking       = false;
  let scroll         = null;
  let offset         = 70;
  let isPinned       = true;
  let rAF            = window.requestAnimationFrame;

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  function downOrUp() {
    let lastScroll = location();
    let direction = null;
    if ( lastScroll > scroll ) {
      direction = 'down';
    }
    if ( lastScroll < scroll ) {
      direction = 'up';
    }
    scroll = lastScroll;
    return direction;
  }

  function checkScroll() {
    checking = false;
    let top = location();
    let direction = downOrUp();

    if ( direction === 'up' ) {
      nav.classList.add( activeClass );
      isPinned = !isPinned;
    }

    if ( top > offset && direction === 'down' ) {
      nav.classList.remove( activeClass );
      isPinned = !isPinned;
    }
  }

  function onScroll() {
    if ( !checking ) {
      checking = true;
      rAF( checkScroll );
    }
  }

  function toggleMobileNav() {
    burger.classList.toggle('is-active');
    mobileNav.classList.toggle('is-open');
    html.classList.toggle('noscroll');
  }

  function initMobileNav() {
    burger.addEventListener( 'click', toggleMobileNav );
  }

  function resizeBodyPadding( targetElement ) {
    let height    = targetElement.offsetHeight;
    let navHeight = headerInner.offsetHeight;
    bodyWrap.style.paddingTop  = `${ height }px`;
    mobileNav.style.paddingTop = `${ height - navHeight }px`;
  }

  function closeReferralBanner() {
    acumen.track('web-referral-banner_close');
    referralBanner.style.display = 'none';
    resizeBodyPadding( nav );
  }

  function initReferralBanner() {
    if ( referralBanner ) {
      window.addEventListener( 'resize', throttle( () => {
        resizeBodyPadding( nav );
      }, 100 ) );

      referralClose.addEventListener( 'click', closeReferralBanner );
      resizeBodyPadding( nav );
    }
  }

  function initCheckAvailBtns() {
    if ( checkAvail ) {
      checkAvail.addEventListener( 'click', e => {
        e.preventDefault();
        toggleMobileNav();
        if ( !hasCheckAvail ) {
          window.location.href = '/internet#check-availability';
          return;
        }
        jump('#check-availability');
      });
    }

    if ( topCheckAvail ) {
      topCheckAvail.addEventListener( 'click', () => {
        if ( !hasCheckAvail ) {
          window.location.href = '/internet#check-availability';
          return;
        }
      });
    }
  }

  function initContactUsBtns() {
    if ( contactUs ) {
      contactUs.addEventListener( 'click', e => {
        e.preventDefault();
        toggleMobileNav();
        jump('#contact-us');
      });
    }
  }

  function init() {
    window.addEventListener( 'scroll', onScroll );

    initMobileNav();
    initCheckAvailBtns();
    initContactUsBtns();
    initReferralBanner();

    body.addEventListener( 'touchmove', e => {
      if ( !html.classList.contains('noscroll') ) {
        return;
      }
      e.preventDefault();
    });
  }

  init();
});


export default undefined;
